import type { ClassValue } from 'clsx'
import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getPortalUrl(): string {
  return import.meta.env.VITE_PORTAL_URL || 'https://staging.equinox.com.my'
}

export function formatCurrency(
  amount: number,
  currency = 'MYR',
  locale = 'ms-MY'
): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  }).format(amount)
}

export function formatDate(
  dateString: string,
  options?: Intl.DateTimeFormatOptions,
) {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...options,
  })
}
